import React from 'react';
import { Link } from 'react-router-dom';
import { CorsTest } from '@/components/test';

const TestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-4"
          >
            ← Back to App
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">API & CORS Testing</h1>
          <p className="text-gray-600 mt-2">
            Test the connectivity and CORS configuration between frontend and backend
          </p>
        </div>

        <CorsTest />

        <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-md">
          <h3 className="font-semibold text-blue-800">Troubleshooting Tips:</h3>
          <ul className="mt-2 text-sm text-blue-700 space-y-1">
            <li>• If CORS errors occur, check the browser's Network tab for specific error messages</li>
            <li>• Ensure the backend server is running and accessible</li>
            <li>• Verify environment variables are properly configured</li>
            <li>• Check that the backend CORS configuration includes your frontend domain</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestPage;